const breakpoints = {
  mobileSmall: "@media (max-width: 320px)",
  mobile: "@media (min-width: 321px) and (max-width: 480px)",
  mobileUp: "@media (min-width: 321px)",
  mobileOnly: "@media (max-width: 600px)",
  tablet: "@media (min-width: 601px) and (max-width: 768px)",
  tabletUp: "@media (min-width: 601px)",
  tabletLarge: "@media (min-width: 769px) and (max-width: 1024px)",
  tabletLargeUp: "@media (min-width: 769px)",
  desktop: "@media (min-width: 1025px) and (max-width: 1280px)",
  desktopUp: "@media (min-width: 1025px)",
  desktopLarge: "@media (min-width: 1281px) and (max-width: 1440px)",
  desktopXLargeUp: "@media (min-width: 1441px)"
};
export const breakpointsMap = {
  xxs: breakpoints.mobileSmall,
  xs: breakpoints.mobileUp,
  sm: breakpoints.tabletUp,
  md: breakpoints.tabletLargeUp,
  lg: breakpoints.desktopUp,
  xl: breakpoints.desktopXLargeUp
};
export default breakpoints;